'use strict';

var abSlider = require('core/components/slider');
var productTile = require('client_core/components/productTile');
var toastHelpers = require('core/components/toast');
function addProduct(data) {
  var uuid = data.uuid || null;
  var pid = data.pid || null;
  var addProductUrl = data.action || null;
  var productName = data.name || null;
  $.spinner().start();
  $.ajax({
    url: addProductUrl,
    method: 'POST',
    dataType: 'json',
    data: {
      pid: pid,
      uuid: uuid,
      name: productName
    },
    success: function success(response) {
      var alertType = response.success ? 'success' : 'warning';
      toastHelpers.methods.show(alertType, response.msg, false);
      _updateCartData();
    },
    error: function error(_error) {
      console.error('Save For Later Failed:', _error);
      $.spinner().stop();
    }
  });
}
function removeProduct(data, skipMsg) {
  var uuid = data.uuid || null;
  var pid = data.pid || null;
  var removeProductUrl = data.action || null;
  var productName = data.name || null;
  $.ajax({
    url: removeProductUrl,
    method: 'GET',
    dataType: 'json',
    data: {
      pid: pid,
      uuid: uuid,
      name: productName
    },
    success: function success(response) {
      if (!skipMsg) {
        var alertType = response.success ? 'success' : 'warning';
        toastHelpers.methods.show(alertType, response.msg, false);
      }
      _updateCartData();
    },
    error: function error(_error2) {
      console.error('Remove From Save For Later Failed:', _error2);
      $.spinner().stop();
    }
  });
}
function moveToCart(data) {
  var uuid = data.uuid || null;
  var pid = data.pid || null;
  var addToCartUrl = data.action || null;
  var productName = data.name || null;
  $.spinner().start();
  $.ajax({
    url: addToCartUrl,
    method: 'POST',
    dataType: 'json',
    data: {
      pid: pid,
      uuid: uuid,
      name: productName,
      quantity: 1
    },
    success: function success(response) {
      var alertType = response.error ? 'warning' : 'success';
      toastHelpers.methods.show(alertType, response.message, false);
      if (response.error === false) {
        $('.empty-cart-content').hide();
        data.action = data.removeaction;
        removeProduct(data, true);
        abSlider.initializeSliders($parsedHtml.body);
        productTile.init($parsedHtml.body);
      }
    },
    error: function error(_error3) {
      console.error('Add To Cart Failed:', _error3);
      $.spinner().stop();
    }
  });
}
function _updateCartData() {
  $.spinner().stop();
  $.spinner().start();
  window.location.reload();
}
module.exports = {
  saveProductForLater: function saveProductForLater() {
    $('body').on('click', '.save-for-later-btn', function (e) {
      e.preventDefault();
      addProduct($(this).data());
    });
  },
  removeProductSavedForLater: function removeProductSavedForLater() {
    $('body').on('click', '.remove-save-for-later-btn', function (e) {
      e.preventDefault();
      removeProduct($(this).data());
    });
  },
  addToCartSavedForLater: function addToCartSavedForLater() {
    $('body').on('click', '.move-to-cart-save-for-later-btn', function (e) {
      e.preventDefault();
      moveToCart($(this).data());
    });
  },
  updateCartData: function updateCartData() {
    $('body').on('cart:updateData', _updateCartData);
  }
};